import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { LabelSetting } from '../../i18n/locale-helper';

@Component({
  template: require("./template.html")
})
class DateRangePickerComponent extends Vue {
  @Prop({ default: null })
  value: any[];

  @Prop({ default: () => {}})
    options: any;

  @Prop({ default: "mini" })
  size: string;

  _interval = null;

  get FromDate() {
    if (this.value) {
      return this.value[0];
    }

    return null;
  }

  set FromDate(value) {
    if (!value) {
      this.$emit("input", [null, this.ToDate]);
    } else {
      this.$emit("input", [value, this.ToDate]);
    }
  }

  get ToDate() {
    if (this.value) {
      return this.value[1];
    }

    return null;
  }

  get lblGlobal() {
    return LabelSetting.Global;
  }

  set ToDate(value) {
    if (!value) {
      this.$emit("input", [this.FromDate, null]);
    } else {
      this.$emit("input", [this.FromDate, value]);
    }
  }

  get pickerOption () {
    //Cause default type is "Date"
    let opts = {...this.options} || {};
    opts.firstDayOfWeek = 1;
    opts.disabledDate = this.disabledEndDate;

    return opts;
}

  handleChangeStart() {
    clearTimeout(this._interval);
    this._interval = setTimeout(() => {
      this.$emit("change", [this.FromDate, this.ToDate]);
    }, 1000);
  }

  handleChangeEnd() {
    clearTimeout(this._interval);
    this._interval = setTimeout(() => {
      this.$emit("change", [this.FromDate, this.ToDate]);
    }, 500);
  }

  focusPicker(){
    clearTimeout(this._interval);
  }

  disabledEndDate(d){
    if(!this.FromDate)
    {
      return false;
    }

    return d < this.FromDate;
  }

  disabledStartDate(d){
    if(!this.ToDate)
    {
      return false;
    }

    return d > this.ToDate;
  }

  beforeDestroy(){
    clearTimeout(this._interval);
    this._interval = null;
  }
}

export default DateRangePickerComponent;
